import { render } from "./PopupComponent.vue?vue&type=template&id=f3fd3ff0&scoped=true"
import script from "./PopupComponent.vue?vue&type=script&lang=js"
export * from "./PopupComponent.vue?vue&type=script&lang=js"

import "./PopupComponent.vue?vue&type=style&index=0&id=f3fd3ff0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3fd3ff0"]])

export default __exports__